import React from "react";
import styled from "styled-components";
import { H5, TextLink } from "../Texts";

export const Style = styled.label`
  background: ${(props) => props.bg || "#FFFFFF"};
  border-radius: 4px;
  border: ${(props) =>
    (props.selected && props.selected === true
      ? "2px solid #442ECF"
      : "2px solid #E7E5F2") || props.border};
  transition: 0.3s ease-in;

  &:hover {
    border: ${(props) => props.hoverBorder || "2px solid #442ECF"};
  }

  &:focus {
    outline: none;
    border: 2px solid #442ecf;
  }
`;

export const FileInput = React.forwardRef(
  (
    {
      className,
      id,
      name,
      label,
      labelColor = "#1E202A",
      onChange,
      required,

      ...rest
    },
    ref,
  ) => {
    const [file, setFile] = React.useState(null);
    const inputRef = React.useRef(null);

    const handleFileChange = (event) => {
      const selectedFile = event.target.files[0];
      if (selectedFile) {
        setFile(selectedFile.name);
        onChange(selectedFile);
      } else {
        setFile(null);
        onChange(null);
      }
    };

    React.useImperativeHandle(ref, () => ({
      ...inputRef.current,
      clear: () => {
        setFile(null);
        if (inputRef.current) {
          inputRef.current.value = "";
        }
      },
    }));

    return (
      <div>
        <Style
          htmlFor={id}
          className="p-10 flex flex-col justify-center items-center mx-auto relative cursor-pointer"
          selected={file != null}
          border="solid 2px #E7E5F2"
          hoverBorder="solid 2px #442ECF"
        >
          <H5 color="#0D024E">{label ?? "Upload file"}</H5>
          {file && <TextLink className="mt-2 mb-4 italic">{file}</TextLink>}
          <input
            type="file"
            ref={inputRef}
            name={name}
            id={id}
            required={required}
            onChange={handleFileChange}
            className="w-0 h-0 opacity-0 absolute"
            {...rest}
          />
        </Style>
      </div>
    );
  },
);
